import Stack from '@mui/material/Stack';
import { WelcomeTemplateEntity } from '../../../../../types';
import SimpleDrawer from '../../../../shared/simple-drawer-new';
import StepWelcomeTemplateReview from './form-step/step-welcome-template-review';

interface WelcomeTemplateDetailsDrawerProps {
  open: boolean;
  handleClose: () => void;
  selectedWelcomeTemplate: WelcomeTemplateEntity | null;
}

export default function WelcomeTemplateDetailsDrawer({
  open,
  handleClose,
  selectedWelcomeTemplate,
}: Readonly<WelcomeTemplateDetailsDrawerProps>) {
  return (
    <SimpleDrawer
      open={open}
      onClose={handleClose}
      title="Welcome Template Details"
    >
      {selectedWelcomeTemplate && (
        <Stack spacing={2}>
          <StepWelcomeTemplateReview
            selectedTemplate={selectedWelcomeTemplate}
            isDrawer
          />
        </Stack>
      )}
    </SimpleDrawer>
  );
}
